import ApiService from './_api.service'

const API_TASKS_URL = '/v1/tasks/'

const TaskService = {
    // Tasks
    readTasks: async function(args) {
        let url = API_TASKS_URL

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }

        return ApiService.get(url + queryParams)
    },

    // Total Tasks
    readTotalTasks: async function() {
        const url = API_TASKS_URL + 'total/'
        const totalTasks = (await ApiService.get(url)).data
        return totalTasks
    }
}

export default TaskService
export { TaskService }
